import { render, staticRenderFns } from "./VistaProducto.vue?vue&type=template&id=2cd2d337&scoped=true&"
import script from "./VistaProducto.vue?vue&type=script&lang=js&"
export * from "./VistaProducto.vue?vue&type=script&lang=js&"
import style0 from "./VistaProducto.vue?vue&type=style&index=0&id=2cd2d337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2d337",
  null
  
)

export default component.exports